import { combineReducers } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { EMPTY_OBJECT } from 'lib/constants';

import comments from './comments';
import currentMealSelectionIds from './currentMealSelectionIds';
import favorites from './favorites';
import mealNotes from './mealNotes';
import mealsSlice from './meals';
import paging from './paging';
import reviews, * as fromReviews from './reviews';
import reviewStatus from './reviewStatus';
import searchParams from './searchParams';
import status from './status';

export default combineReducers({
  comments,
  currentMealSelectionIds,
  meals: mealsSlice.reducer,
  paging,
  reviews,
  reviewStatus,
  searchParams,
  status,
  favorites,
  mealNotes,
});

const selectCookbook = state => state.cookbook;

export const selectComments = state => selectCookbook(state).comments;
export const selectMealIds = state => selectCookbook(state).currentMealSelectionIds;
export const selectMeals = state => selectCookbook(state).meals;

export const selectPaging = state => selectCookbook(state).paging;
export const selectReviews = state => selectCookbook(state).reviews;
export const selectReviewStatus = state => selectCookbook(state).reviewStatus;
export const selectSearchParams = state => selectCookbook(state).searchParams;
export const selectStatus = state => selectCookbook(state).status;
export const selectFavorites = state => selectCookbook(state).favorites.data || EMPTY_OBJECT;
export const selectFavoritesFetched = state => selectCookbook(state).favorites.isFetched || false;
export const selectFavoritesLoading = state => selectCookbook(state).favorites.isLoading || false;
export const selectMealNotes = state => selectCookbook(state).mealNotes;

export const selectReview = (state, id) => fromReviews.selectReview(selectReviews(state), id);
export const selectMealNote = (state, id) => get(selectMealNotes(state), id);
